import { api } from '@/core/api/';

const baseApiURL = 'api/providers/consulting';

export const getAcademicYears = () => api.get(`${baseApiURL}/academicyears`);
export const getMonths = (academicYearId) =>
  api.get(`${baseApiURL}/${academicYearId}/months`);
export const getSpecialists = (academicYearId, companyId, serviceLocationId) =>
  api.get(`${baseApiURL}/${academicYearId}/specialists`, {
    params: {
      companyId,
      serviceLocationId,
    },
  });
export const getActivities = () => api.get(`${baseApiURL}/activities`);
export const getContractActivities = (date) =>
  api.get(`${baseApiURL}/contract-activities?date=` + date);
export const getProviders = (academicYearId) =>
  api.get(`${baseApiURL}/${academicYearId}/providers`);
export const searchConsulting = (
  academicYearId,
  companyId,
  monthNumber,
  specialistId,
  activityId,
  centerId,
  serviceLocationId,
  currentPage,
  pageSize
) =>
  api.get(`${baseApiURL}/${academicYearId}`, {
    params: {
      companyId,
      monthNumber,
      specialistId,
      serviceLocationId,
      activityId,
      centerId,
      currentPage,
      pageSize,
    },
  });
export const getFinalizedBillingStatus = (
  academicYearId,
  companyId,
  monthNumber,
  specialistId,
  centerId
) =>
  api.get(`${baseApiURL}/finalizedbillingstatus/${academicYearId}`, {
    params: {
      companyId,
      monthNumber,
      specialistId,
      centerId,
    },
  });
export const _getTrainningDetail = (id) =>
  api.get(`${baseApiURL}/detail/${id}`);

export const _getDurations = (activityid) =>
  api.get(`${baseApiURL}/${activityid}/durations`);

export const _saveTraining = (model) =>
  api.post(`${baseApiURL}/detail/save`, model, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const _isInvoiceRelated = (id) =>
  api.get(`${baseApiURL}/isinvoicerelated/${id}`);

export const _deleteTraining = (id) =>
  api.delete(`${baseApiURL}/deleteconsulting/${id}`);

export const _getDocumentTypes = (activityid, consultingId) =>
  api.get(
    `${baseApiURL}/documenttypes/${activityid}?consulingId=${consultingId}`
  );

export const _getParticipantTypes = () =>
  api.get(`${baseApiURL}/participanttypes`);

export const _isCostNeeded = (model) =>
  api.get(`${baseApiURL}/iscostneeded`, {
    params: model,
  });
